import { render, staticRenderFns } from "./Pendiente.vue?vue&type=template&id=d153793c&"
import script from "./Pendiente.vue?vue&type=script&lang=js&"
export * from "./Pendiente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports